export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/recommendSingleVehicle.worker.620e4ee5.worker.js");
}
